import styled from 'styled-components';

const IconStyle = styled.div`
	--iconSize: var(--sp2-5x);

	height: fit-content;
	width: fit-content;

	.icon-wrap {
		height: fit-content;
		width: fit-content;

		svg {
			display: flex;
			width: var(--iconSize);
			height: var(--iconSize);
			transition: var(--trTime) ease-out;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--iconSize: var(--sp2x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;
export default IconStyle;
